import { taskIcons } from 'configs';
import React from 'react';
import { components } from 'react-select';

const IconOption = (props) => {
  const { Option } = components;
  const {
    data: { value },
  } = props;
  const Icon = taskIcons[value];

  return (
    <Option {...props}>
      <Icon />
    </Option>
  );
};

export default IconOption;
